// Add your custom JS here.
import lozad from 'lozad';

const observer = lozad();
observer.observe();

const isMobile = () => {
    // Check if the new API is supported
    if (navigator.userAgentData) {
        return navigator.userAgentData.mobile;
    }

    // Fallback for Safari/Firefox (see Solution 3)
    return /Mobi|Android/i.test(navigator.userAgent);
};


($ => {
    $.fn.textWidth = function () {
        var html_org = $(this).html();
        var html_calc = '<span>' + html_org + '</span>';
        $(this).html(html_calc);
        var width = $(this).find('span:first').width();
        $(this).html(html_org);
        return width;
    };
    /*Bouton pour remonter en haut de page*/
    $('body').append('<div id="back_top" class="bg-primary"><i class="fas fa-arrow-up text-white"></i></div>');
    $('#back_top').click(function () {
        $('html,body').animate({scrollTop: 0}, 'slow');
    });

    let width = $(window).width();
    $(window).scroll(function () {
        // If on top fade the bouton out, else fade it in
        if (0 === $(window).scrollTop()) {
            $('#back_top').fadeOut();
        } else {
            $('#back_top').fadeIn();
        }
    });

    $(document).ready(() => {
        let dataSrc = $('.custom-logo-link img').attr('data-src');
        $('.custom-logo-link img').attr('src', dataSrc);
    });
    var h3Count = 1;
    if ($('#menu').length) {
        $('.contenu-page h2').each(function () {
            $(this).attr('id', 'titre_' + h3Count);
            $('.menu-aside').append('<li><a href="#titre_' + h3Count + '">' + $(this).text() + '</a></li>');
            h3Count++;
        });
    }

    $('.page-template-template-home-editions .editions h2').each(function () {
        $(this).append('<span class="after"></span>');
        var textWidth = $(this).textWidth();
        $(this).find('.after').css('width', 'calc(100% - ' + textWidth + 'px)');
    });

    $('.editions h1').each(function () {
        $(this).append('<span class="after"></span>');

        if (!isMobile()) {
            var textWidth = $(this).textWidth();
            if (! $(this).parent().parent().hasClass('presentation')) {
                $(this).find('.after').css('width', 'calc(100% - ' + textWidth + 'px)');
            }
        }
    });

    $('#submit').on('click', function(){
        $(this).parent('form').submit();
    })

})(jQuery);



